import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { CookieStorage } from 'redux-persist-cookie-storage';
import Cookies from 'cookies-js';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import history from '../history';

import versionReducer, { initialVersionState } from './version';
import iocListReducer, { initialIocListState } from './ioc';
import appReducer, { initialAppState } from './app';
import authReducer, { initialAuthState } from './auth';
import blogReducer, { initialBlogState } from './blog';
import subscriptionReducer, { initialSubscriptionState } from './subscription';
import userReducer, { initialUserState } from './user';
import sidebarReducer, { initialSidebarState } from './sidebar';
import filterReducer, { initialFilterState } from './filter';
import feedReducer, { initialFeedState } from './feed';
import sourceReducer, { initialSourceState } from './source';
import integrationReducer, { initialIntegrationState } from './integrations';
import tagsReducer, { initialTagState } from './tags';
import groupsReducer, { initialGroupsState } from './groups';
import departmentsReducer, { initialDepartmentsState } from './departments';
import permissionsReducer, { initialPermissionsState } from './permissions';
import dashboardsReducer, { initialDashboardsState } from './dashboards';
import widgetsReducer, { initialWidgetsState } from './widgets';
import playbooksReducer, { initialPlaybooksState } from './playbooks';
import APIAccessReducer, { initialAPIAccessState } from './APIAccess';
import staffReducer, { initialCustomerOrganizationsState } from './staff';
import notificationReducer, { initialNotificationState } from './notifications';
import downloadReducer, { initialDownloadState } from './download';
import leftMenuReducer, { initialLeftMenuState } from './leftMenu';
import deepScanReducer, { initialDeepScanState } from './deep_scan';
import bulkdata, { initialBulkDataState } from './bulkdata';
import marketplace, { initialMarketplaceState } from './marketplace';
import { STATUS } from '../constants';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

const appPersistConfig = {
  key: 'app',
  storage: storage,
  stateReconciler: autoMergeLevel2,
  blacklist: [],
};
const authPersistConfig = {
  key: 'token',
  storage: new CookieStorage(Cookies),
  //stateReconciler: autoMergeLevel2,
  whitelist: ['token'],
};
const authRefreshTokenPersistConfig = {
  key: 'refreshToken',
  storage: new CookieStorage(Cookies),
  //stateReconciler: autoMergeLevel2,
  whitelist: ['refreshToken'],
};

const iocPersistConfig = {
  key: 'ioc',
  storage: new CookieStorage(Cookies, {
    expiration: {
      threat_ranking_cached_flag: 300,
    },
  }),
  // stateReconciler: autoMergeLevel2,
  whitelist: ['threat_ranking_cached_flag'],
};

export const initialState = {
  version: initialVersionState,
  ioc: initialIocListState,
  app: initialAppState,
  auth: initialAuthState,
  bulkdata: initialBulkDataState,
  marketplace: initialMarketplaceState,
  blog: initialBlogState,
  subscription: initialSubscriptionState,
  user: initialUserState,
  sidebar: initialSidebarState,
  filter: initialFilterState,
  feed: initialFeedState,
  integration: initialIntegrationState,
  tags: initialTagState,
  groups: initialGroupsState,
  departments: initialDepartmentsState,
  permissions: initialPermissionsState,
  dashboards: initialDashboardsState,
  widgets: initialWidgetsState,
  playbooks: initialPlaybooksState,
  APIAccess: initialAPIAccessState,
  staff: initialCustomerOrganizationsState,
  notification: initialNotificationState,
  download: initialDownloadState,
  leftMenu: initialLeftMenuState,
  deepScan: initialDeepScanState,
};

const createReducer = combineReducers({
  app: persistReducer(appPersistConfig, appReducer),
  auth: persistReducer(authPersistConfig, authReducer),
  blog: blogReducer,
  APIAccess: APIAccessReducer,
  bulkdata: bulkdata,
  marketplace: marketplace,
  download: downloadReducer,
  departments: departmentsReducer,
  dashboards: dashboardsReducer,
  filter: filterReducer,
  feed: feedReducer,
  groups: groupsReducer,
  integration: integrationReducer,
  ioc: persistReducer(iocPersistConfig, iocListReducer),
  notification: notificationReducer,
  router: connectRouter(history),
  leftMenu: leftMenuReducer,
  permissions: permissionsReducer,
  playbooks: playbooksReducer,
  source: sourceReducer,
  subscription: subscriptionReducer,
  sidebar: sidebarReducer,
  staff: staffReducer,
  tags: tagsReducer,
  refresh: persistReducer(authRefreshTokenPersistConfig, authReducer),
  user: userReducer,
  widgets: widgetsReducer,
  version: versionReducer,
  deepScan: deepScanReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'App/LOGOUT') {
    const stateCopy = { ...state };
    stateCopy['user']['mySubscriptionPlan'] = [];
    stateCopy['user']['mySubscriptionPlanStatus'] = STATUS.IDLE;
    const websocketConnection = stateCopy['user']['websocketConnection'];
    if (
      websocketConnection &&
      websocketConnection.readyState === WebSocket.OPEN
    ) {
      // alert('we should close websocekt');
      websocketConnection.close();
    }
    stateCopy['user']['websocketConnection'] = null;
    stateCopy['user']['websocketConnectionStatus'] = STATUS.IDLE;

    return createReducer(stateCopy, action);
  }
  return createReducer(state, action);
};

export default rootReducer;
